import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

const TEST_NAME = 'expandAppDownloadTriggers_Jan2026';

function getExpandAppDownloadTestVariant(): string | undefined {
    return getAbTestV2(TEST_NAME)?.variant;
}

function trackExpandAppDownloadAbTest(): void {
    trackAbTestV2Variant(TEST_NAME);
}

export { getExpandAppDownloadTestVariant, trackExpandAppDownloadAbTest };
